export const BRAND_NAME = "Tadka";
export const BRAND_TAGLINE = "Hot food, delivered the moment it's ready.";

export const PROXY_SERVER = "https://proxy.akashprojects.dev/";

// Hardcoded to New Delhi for this demo — no location picker implemented.
export const DELHI_LAT = 28.7040592;
export const DELHI_LNG = 77.10249019999999;

export const CART_STORAGE_KEY = "tadka-cart";
